<template>
    <div class="card border-0 bg-wash no-shadow">
        <div class="card-body no-gutters px-0">
            <div class="float-left ml-0 custom-search col-md-6">
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        <b-icon icon="search"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" placeholder="Search Message" v-model="search" @input="resetPagination()"></b-form-input>
                </b-input-group>
            </div>
            <div class="float-right col-md-6 text-right pr-0">
                <b-button id="show-btn" v-if="ce" @click="addNewBank()"><b-icon icon="plus" ></b-icon> New Bank</b-button>
            </div>
        </div>

        <!-- {{ paginatedData }} -->
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>

        <b-overlay :show="showoverlay" rounded="sm" class="card-body container p-0">
            <div class="card-body container-fluid p-0">
                <div class="row table-head py-2 no-margin">
                    <div class="col-10 py-1 pl-2 font-weight-bold align-self-center">                
                        Name
                    </div>                
                    
                    <div class="col-2 py-1 pl-2 font-weight-bold text-right">                
                        Action
                    </div>
                </div>

                
                <div class="row border-bottom py-10 hover-bg table-row border-bottom no-margin" v-for="bank in paginatedData" :key="bank.id">

                    <div class="col-10 py-1 pl-2 align-self-center">                
                        {{bank.name}}
                    </div>                
                    
                    <div class="col-2 py-1 pl-2">
                        <div class="float-right position-relative">
                            <b-button-toolbar>
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                    <b-button-group >
                                        <b-button variant="outline-secondary" v-if="ce" @click="editBank(bank.id)">
                                            <b-icon icon="pencil"></b-icon> Edit
                                        </b-button>

                                       
                                    </b-button-group>
                                </div>
                            </b-button-toolbar>
                         </div>
                    </div>
                </div>
                
                <div class="row p-2 float-right" v-if="paginatedData.length > 0">
                    <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                </div>
                <div class="row p-2" v-if="paginatedData.length == 0">
                    {{blankmsg}}
                </div>
            </div>
        </b-overlay>
        
        
        <b-modal id="bv-modal-example" size="lg" hide-footer title="Message Details">
            

                <!--<ul class="list-group mb-3 " v-if='errormsg'>           
                    <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                </ul>-->

                <b-overlay :show="showoverlaymodal" rounded="sm">
                    <b-form @submit.stop.prevent="onSubmit">
                        <input type="hidden" v-model="fdata.id" name="id">                        

                        <b-form-group id="name-group" class="half-width mr1" label="Name" label-for="name">
                            <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                        </b-form-group>
                        
                        
                        <div class="full-width">
                            <b-button type="submit" variant="success">Submit</b-button>
                            <b-button class="ml-2" variant="success" @click="resetForm()">Reset</b-button>
                        </div>
                    </b-form> 
                </b-overlay>               
        </b-modal>

    </div>
</template>


<script>
    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
            
        },
        data(){            
            
            return {
                cu : window.location.href,
                ce : false, 
                
                
                pagetitle: '',
                search:'',
                listdata : [],                 
                banks : [],                 
                successmsg : '',
                errormsg : [],
                blankmsg : 'Fetching data..',
                fdata : {id:null, name:''},

                showoverlay : false,
                showoverlaymodal : false,


                length: 30,
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                
            }
        },
        methods:{
            getAcl: function()
            {                
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            },
            getBanks: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/allbanks/list').then(function(response){
                    //console.log(response.data);
                    this.banks = response.data;
                    this.pagination.total = response.data.length;

                    this.showoverlay = false;

                    if(this.banks.length == 0)
                        this.blankmsg = "Nothing found.";
                }.bind(this));
            }, 
            editBank:function(x)
            { 
                if(!this.checkNet()) return false;
                let currentObj = this;
                     
                this.errormsg = [];
                this.successmsg = '';
                axios.get(this.$api_url+'/bank' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.$validator.reset();
                }.bind(this))
                .catch(function (error)
                {
                    currentObj.serverError(error);
                });

                this.$bvModal.show('bv-modal-example');
                
            },
            deleteMsg:function(x)
            {

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {id:null, name:''};
                
                this.$nextTick(() => {
                    this.$validator.reset();
                });

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNewBank()
            {
                this.resetForm();
                this.$bvModal.show('bv-modal-example');
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    //this.showoverlaymodal = true;
                    e.preventDefault();
                    let currentObj = this;
                    

                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);      
                    } 

                    axios.post(this.$api_url+'/bank', formData)
                                .then(function (response) 
                                {                             
                                    this.getBanks();
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        }); 

                                    this.$bvModal.hide('bv-modal-example');
                                    this.showoverlaymodal = false;                                    
                                    this.resetForm();
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                                    
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;                                    
                                    for (var data in currentObj.errormsg)
                                    {
                                        var msg = currentObj.errormsg[data];
                                        currentObj.$bvToast.toast(msg, {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        }); 
                                        currentObj.$validator.reset();
                                    }
                                });
                });
            },


        },
        created: function(){
            this.getAcl();
            this.getBanks();
            Fire.$on('reloadUsers', () => {this.getBanks()})
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.banks;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>